(function(){
  function qs(selector, context){return (context || document).querySelector(selector)}

  const mobileCalmCss = `
  .knl-lifestyle-hero{width:min(1180px,calc(100% - 40px));margin:28px auto 18px;display:grid;grid-template-columns:minmax(0,720px) minmax(260px,1fr);gap:24px;align-items:end;color:#173126}
  .knl-lifestyle-scene{position:relative;aspect-ratio:4/5;overflow:hidden;border-radius:28px;border:1px solid rgba(201,162,75,.22);background-color:#12261d;background-repeat:no-repeat;background-size:300% 1300%;box-shadow:0 30px 70px -48px rgba(23,49,38,.8)}
  .knl-lifestyle-badge{position:absolute;left:16px;bottom:16px;padding:7px 10px;border:1px solid rgba(255,255,255,.28);border-radius:999px;background:rgba(18,38,29,.78);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#f3dfab;font:800 9px/1 system-ui,sans-serif;letter-spacing:.12em;text-transform:uppercase}
  .knl-lifestyle-copy{padding:0 4px 18px}.knl-lifestyle-copy small{display:block;color:#c9a24b;font:800 9px/1.2 system-ui,sans-serif;letter-spacing:.16em;text-transform:uppercase}.knl-lifestyle-copy h2{margin:11px 0 10px;font:500 clamp(30px,4vw,46px)/1.04 Georgia,serif;letter-spacing:-.035em;color:#173126}.knl-lifestyle-copy p{margin:0;color:#5f7166;font:500 13px/1.7 system-ui,sans-serif}.knl-lifestyle-copy a{display:inline-block;margin-top:16px;color:#294b3a;font:800 10px/1 system-ui,sans-serif;letter-spacing:.06em;text-underline-offset:4px}
  @media(max-width:749px){
    html,body{scroll-behavior:auto!important}
    body{scroll-padding-top:142px!important}
    ::view-transition-old(root),::view-transition-new(root){animation:none!important}
    body *{animation-duration:0s!important;animation-delay:0s!important;transition-duration:0s!important;transition-delay:0s!important}
    .km-rise{animation:none!important;opacity:1!important;transform:none!important}
    .kms-nav-shell{position:sticky!important;top:0!important;z-index:999!important;transform:none!important;animation:none!important;box-shadow:0 10px 28px -27px rgba(23,49,38,.8)!important}
    .kms-announcement{min-height:0!important;padding:7px 14px!important;white-space:normal!important;text-align:center!important;line-height:1.35!important}
    .kms-announcement span,.kms-announcement p{margin:0!important;line-height:1.35!important}
    .kms-mainbar{min-height:58px!important}
    .kms-routebar{display:block!important;position:relative!important;background:rgba(251,248,241,.98)!important;border-top:1px solid rgba(41,75,58,.08)!important;border-bottom:1px solid rgba(41,75,58,.12)!important}
    .kms-route-scroll{display:flex!important;align-items:center!important;gap:7px!important;overflow-x:auto!important;overflow-y:hidden!important;padding:8px 14px!important;scrollbar-width:none!important;overscroll-behavior-x:contain!important;-webkit-overflow-scrolling:touch!important}
    .kms-route-scroll::-webkit-scrollbar{display:none!important}
    .kms-route-scroll a{flex:0 0 auto!important;white-space:nowrap!important;min-height:34px!important;display:inline-flex!important;align-items:center!important;padding:0 12px!important;border-radius:999px!important}
    .kms-mobile-panel,.kms-search-overlay,.kms-search-box,.kms-menu-btn,.kms-icon-btn{animation:none!important;transition:none!important}
    .na-nav{position:fixed!important;top:0!important;z-index:999!important;transform:none!important;animation:none!important}
    .na-depts{position:sticky!important;top:58px!important;z-index:88!important;background:rgba(18,38,29,.98)!important;backdrop-filter:blur(18px)!important;-webkit-backdrop-filter:blur(18px)!important;padding-left:13px!important;padding-right:13px!important;margin-left:-13px!important;margin-right:-13px!important}
    .na-card:hover,.na-primary:hover,.na-secondary:hover,.na-concierge-btn:hover,.na-icon-btn:hover{transform:none!important;filter:none!important}
    .na-concierge,.na-saved-drawer,.na-overlay,.na-search-panel{transition:none!important;animation:none!important}
    .knl-lifestyle-hero{width:calc(100% - 28px);margin:16px auto 10px;display:block}
    .knl-lifestyle-scene{border-radius:22px;aspect-ratio:4/5}
    .knl-lifestyle-copy{padding:16px 4px 12px}.knl-lifestyle-copy h2{font-size:30px}.knl-lifestyle-copy p{font-size:12px}
  }
  @media(max-width:390px){body{scroll-padding-top:136px!important}.kms-route-scroll{padding-left:10px!important;padding-right:10px!important}.kms-route-scroll a{padding:0 10px!important}}
  `;

  if(!document.getElementById('KalaMobileCalmStyles')){
    const style = document.createElement('style');
    style.id = 'KalaMobileCalmStyles';
    style.textContent = mobileCalmCss;
    document.head.appendChild(style);
  }

  const main = qs('#MainContent');
  if(main){
    main.setAttribute('data-page-transition-enabled','false');
    main.setAttribute('data-product-transition','false');
  }

  const lifestyleMap = {
    'nana-mug':[0,0],'oma-mug':[50,0],'slow-mornings-mug':[100,0],
    'nonna-mug':[0,8.3333],'tia-mug':[50,8.3333],'tio-mug':[100,8.3333],
    'opa-mug':[0,16.6667],'nana-of-one-mug':[50,16.6667],'our-family-established-mug':[100,16.6667],
    'little-legacy-coffee-mug-11oz-15oz':[0,25],'more-father-than-i-knew-coffee-mug-11oz-15oz':[50,25],'raising-a-whole-human-coffee-mug-11oz-15oz':[100,25],
    'her-first-home-was-me-coffee-mug-11oz-15oz':[0,33.3333],'the-calm-in-this-house-coffee-mug-11oz-15oz':[50,33.3333],'20oz-insulated-tumbler-but-first-snuggles-travel-mug':[100,33.3333],
    'little-by-little-we-grow-bodysuit':[0,41.6667],'calm-curious-kind-baby-bodysuit':[50,41.6667],'the-softest-days-bodysuit':[100,41.6667],
    'hello-little-love-bodysuit':[0,50],'lumi-on-the-moon-toddler-sweatshirt-nureli-kids':[50,50],'small-but-mighty-toddler-sweatshirt-nureli-kids':[100,50],
    'one-of-a-kind-toddler-sweatshirt-nureli-kids':[0,58.3333],'the-future-is-bright-kids-sweatshirt-nureli-kids':[50,58.3333],'made-with-love-kids-sweatshirt-nureli-kids':[100,58.3333],
    'brave-little-lion-kids-sweatshirt-nureli-kids':[0,66.6667],'the-days-are-long-but-the-years-are-short-tote':[50,66.6667],'raising-my-little-wonder-tote':[100,66.6667],
    'lumi-tote':[0,75],'one-little-wonder-tote':[50,75],'nurture-their-minds-inspire-their-hearts-tote':[100,75],
    'one-little-wonder-journal':[0,83.3333],'the-days-are-long-but-the-years-are-short-journal':[50,83.3333],'nurture-their-minds-inspire-their-hearts-journal':[100,83.3333],
    'little-by-little-we-grow-journal':[0,91.6667],'breathe-deep-let-go-youve-got-this-journal':[50,91.6667],'i-survived-the-fourth-trimester-journal':[100,91.6667],
    'im-growing-a-human-journal':[0,100],'our-whole-world-journal':[50,100],'brave-little-heart-journal':[100,100]
  };

  function addLifestyleHero(){
    const match = location.pathname.match(/^\/products\/([^/?#]+)/);
    if(!match || !main || qs('[data-knl-lifestyle-hero]')) return;
    const handle = decodeURIComponent(match[1]);
    const pos = lifestyleMap[handle];
    if(!pos) return;
    const titleNode = qs('h1', main);
    const title = titleNode ? titleNode.textContent.trim() : 'Nureli piece';
    const sprite = 'https://cdn.shopify.com/s/files/1/0776/9862/9790/files/nureli-mockups-master-sprite.webp?v=1786830317';
    const section = document.createElement('section');
    section.className = 'knl-lifestyle-hero';
    section.setAttribute('data-knl-lifestyle-hero','');
    section.innerHTML = '<div class="knl-lifestyle-scene" role="img" aria-label="Styled lifestyle view of '+title.replace(/"/g,'&quot;')+'"><span class="knl-lifestyle-badge">Styled lifestyle view</span></div><div class="knl-lifestyle-copy"><small>Nureli · in context</small><h2>'+title.replace(/</g,'&lt;').replace(/>/g,'&gt;')+'</h2><p>The exact product design, shown in a considered setting. The real Shopify product gallery, colors, variants and checkout follow directly below.</p><a href="#ProductInfo">See product details ↓</a></div>';
    const scene = qs('.knl-lifestyle-scene', section);
    scene.style.backgroundImage = 'url("'+sprite+'")';
    scene.style.backgroundPosition = pos[0]+'% '+pos[1]+'%';
    main.insertBefore(section, main.firstChild);
  }
  addLifestyleHero();

  const shell = qs('[data-kms-shell]');
  if(!shell) return;

  const menuButton = qs('[data-kms-menu]', shell);
  const mobilePanel = qs('[data-kms-mobile]', shell);
  const searchOverlay = qs('[data-kms-search]');
  const cartLink = qs('.kms-cart-link', shell);
  let previousOverflow = '';

  function setMenu(open){
    if(!mobilePanel || !menuButton) return;
    mobilePanel.hidden = !open;
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
  }

  function setSearch(open){
    if(!searchOverlay) return;
    searchOverlay.classList.toggle('is-open', open);
    searchOverlay.setAttribute('aria-hidden', String(!open));
    if(open){
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      const input = qs('input[type="search"]', searchOverlay);
      setTimeout(function(){if(input) input.focus()}, 50);
    }else{
      document.documentElement.style.overflow = previousOverflow;
    }
  }

  function syncCartCount(count){
    if(!cartLink || !Number.isFinite(count)) return;
    let badge = qs('.kms-cart-count', cartLink);
    if(count > 0){
      if(!badge){
        badge = document.createElement('span');
        badge.className = 'kms-cart-count';
        badge.setAttribute('aria-hidden', 'true');
        cartLink.appendChild(badge);
      }
      badge.textContent = count > 99 ? '99+' : String(count);
    }else if(badge){
      badge.remove();
    }
    cartLink.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));
  }

  async function refreshCartCount(){
    try{
      const response = await fetch('/cart.js', {headers:{Accept:'application/json'}});
      if(!response.ok) return;
      const cart = await response.json();
      syncCartCount(Number(cart.item_count) || 0);
    }catch(error){}
  }

  document.addEventListener('cart:update', function(event){
    const count = Number(event.detail && event.detail.resource && event.detail.resource.item_count);
    if(Number.isFinite(count)) syncCartCount(count);
    else refreshCartCount();
  });

  window.addEventListener('pageshow', function(event){
    if(event.persisted) refreshCartCount();
  });

  document.addEventListener('click', function(event){
    if(event.target.closest('[data-kms-menu]')){
      setMenu(mobilePanel ? mobilePanel.hidden : true);
      return;
    }
    if(event.target.closest('[data-kms-search-open]')){
      setSearch(true);
      return;
    }
    if(event.target.closest('[data-kms-search-close]')){
      setSearch(false);
      return;
    }
    if(mobilePanel && !mobilePanel.hidden && event.target.closest('[data-kms-mobile] a')){
      setMenu(false);
      return;
    }
    if(mobilePanel && !mobilePanel.hidden && !event.target.closest('[data-kms-shell]')) setMenu(false);
  });

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape'){
      setMenu(false);
      setSearch(false);
    }
    if((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k'){
      event.preventDefault();
      event.stopImmediatePropagation();
      setSearch(true);
    }
  });
})();